export enum MissedPenaltyAttribute {
  LeftFoot = 445,
  RightFoot = 446,
  ShotWoodwork = 447,
  BigChanceMissed = 942,
}
